<template>
  <section class="section">
      <nav>
        <div class="tabs is-centered">
          <div class="ml-auto mr-auto">
            <ul v-if="currentUser.isAdmin" style="padding-left: 0;">
              <li :class="{'is-active': activeTab === 'customerOverview'}"><a @click="showTab('customerOverview')">Customer Overview</a></li>
              <li :class="{'is-active': activeTab === 'auditOrdersTimeline'}"><a @click="showTab('auditOrdersTimeline')">Audit Orders Timeline</a></li>
              <li :class="{'is-active': activeTab === 'siloOrdersTimeline'}"><a @click="showTab('siloOrdersTimeline')">Silo Orders Timeline</a></li>
              <li :class="{'is-active': activeTab === 'contentOrdersTimeline'}"><a @click="showTab('contentOrdersTimeline')">Content Orders Timeline</a></li>
              <li :class="{'is-active': activeTab === 'commissionsTracker'}" v-if="currentUser?.has_view_access_to_commissions_dashboard"><a @click="showTab('commissionsTracker')">Commissions Tracker</a></li>
            </ul>
          </div>
        </div>
      </nav>
      <div>
        <section v-if="activeTab === 'customerOverview'" class="section pt15">
          <customer-overview/>
        </section>
        <section v-if="activeTab === 'auditOrdersTimeline'" class="section pt15">
          <audit-orders-timeline/>
        </section>
        <section v-if="activeTab === 'siloOrdersTimeline'" class="section pt15">
          <silo-orders-timeline/>
        </section>
        <section v-if="activeTab === 'contentOrdersTimeline'" class="section pt15">
          <content-orders-timeline/>
        </section>
        <section v-if="activeTab === 'commissionsTracker' && currentUser?.has_view_access_to_commissions_dashboard" class="section pt15">
          <commissions-tracker/>
        </section>
      </div>
  
  </section>
  </template>
  
  <script>
  import CustomerOverview from '@/components/Admin/WhiteGlove/CustomerOverview.vue'
  import AuditOrdersTimeline from '@/components/Admin/WhiteGlove/AuditOrdersTimeline.vue'
  import SiloOrdersTimeline from '@/components/Admin/WhiteGlove/SiloOrdersTimeline.vue'
  import ContentOrdersTimeline from '@/components/Admin/WhiteGlove/ContentOrdersTimeline.vue'
  import CommissionsTracker from '@/components/Admin/WhiteGlove/CommissionsTracker.vue'

  export default {
    components: {
      CustomerOverview,
      AuditOrdersTimeline,
      SiloOrdersTimeline,
      ContentOrdersTimeline,
      CommissionsTracker,
    },
    data () {
      return {
        activeTab: 'customerOverview',
        ready: false
      }
    },
    methods: {
      showTab (tab) {
        this.activeTab = tab
      }
    },
    computed: {
      isLoading () {
        return this.$store.state.isLoading
      },
      currentUser() {
        if (this.$store.state.user) {
          return this.$store.state.user
        }
        return {}
      },
    },
    mounted () {
      
    }
  }
  </script>
  
  <style lang="scss">
  
  </style>